import { PartnerDetail } from '~/api/partners/_types';

export const usePartnerDetailStore = defineStore('partner', () => {
    const activePartner = ref<PartnerDetail | null>(null);

    const reset = () => {
        activePartner.value = null;
    };

    return {
        activePartner,
        reset,
    };
});
